import { Box, Chip, useTheme } from "@mui/material";
import React, { useMemo } from "react";

import CustomChip from "./CustomChip";

const ShowECPTags = (props: any) => {
  const theme = useTheme();
  const { ecp } = props;

  const ecpTags = useMemo(() => {
    const tagValues = {
      payment: ecp?.payment_tag,
      expert: ecp?.essilor_expert_tag,
      partner: ecp?.essilor_partner_tag,
      nikon: ecp?.nikon_lenswear_partner_tag,
    };

    const updatedTags: Record<string, React.ReactNode> = {};
    Object.entries(tagValues).forEach(([key, tag]) => {
      if (tag?.name) {
        updatedTags[key] = (
          <CustomChip
            label={tag.name}
            textColor={tag.text_color_code}
            bgColor={tag.background_color_code}
          />
        );
      }
    });

    if (ecp?.tags && ecp?.tags.length > 0) {
      ecp.tags.forEach((tag: any, index: number) => {
        updatedTags[`custom-tag-${index}`] = (
          <CustomChip
            label={tag.name}
            textColor={tag.text_color_code}
            bgColor={tag.background_color_code}
            style={{ marginRight: 4 }}
          />
        );
      });
    }
    return updatedTags;
  }, [ecp]);

  return (
    <>
      <Box
        sx={{
          width: "100%",
          borderRadius: "4px",
          minHeight: "56px",
          padding: "8px",
          display: "flex",
          flexWrap: "wrap",
          gap: "8px",
          border: "1px solid #cccccc",
          alignItems: "center",
          "&:hover": {
            border: `1px solid ${theme.vars.palette.primary.main}`,
          },
          "&:active": {
            boxShadow: `inset 0 0 0 1px ${theme.vars.palette.primary.main}`,
          },
        }}
      >
        {ecp?.is_vip && <Chip label="VIP" size="small" color="success" />}
        {Object.keys(ecpTags).map((key, index) => {
          if (ecpTags[key]) {
            return <div key={`tag-key-${index}`}>{ecpTags[key]}</div>;
          }
        })}
      </Box>
    </>
  );
};

export default ShowECPTags;
